import { render } from "./RatesService.vue?vue&type=template&id=9a09e066&scoped=true"
import script from "./RatesService.vue?vue&type=script&lang=js"
export * from "./RatesService.vue?vue&type=script&lang=js"

import "./RatesService.vue?vue&type=style&index=0&id=9a09e066&lang=scss&scoped=true"

import exportComponent from "/var/www/nexgen/apps/nxglabs-web/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a09e066"]])

export default __exports__